import { cn } from "~/lib/utils";
import { ChartConfig } from "~/modules/charts/types";
import { AssetTableChartProvider } from "./AssetTableChartProvider";

// // // //

/**
 * AssetTableChartRenderer
 * Renders the configured columns of `/v4/assets` as a paginated asset table.
 */
export function AssetTableChartRenderer(props: {
    title: string;
    description: string;
    config: ChartConfig;
}) {
    const { title, description, config } = props;

    return (
        <AssetTableChartProvider
            title={title}
            description={description}
            config={config}
        >
            {({
                title,
                description,
                isLoading,
                tableEl,
                loadingEl,
                customControls,
            }) => (
                // NOTE - the layout markup here is pulled from VisualizationCard.tsx
                <div
                    className={cn(
                        "p-0 overflow-hidden bg-card rounded-lg shadow-xs border",
                        "col-span-1 flex flex-col justify-between",
                        `col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 2xl:col-span-12`,
                    )}
                >
                    <div className="flex flex-col p-5 items-start gap-2 mb-2 md:flex-row md:justify-between md:items-center md:gap-0 md:mb-0 border-b">
                        <div className="w-full">
                            <p className="text-foreground text-xl leading select-none">
                                {title}
                            </p>

                            {description !== null && (
                                <p className="select-none text-xs text-muted-foreground font-light tracking-wide">
                                    {description}
                                </p>
                            )}
                        </div>
                        {customControls}
                    </div>
                    {isLoading ? loadingEl : tableEl}
                </div>
            )}
        </AssetTableChartProvider>
    );
}
